import { Typography } from "@mui/material";
import { Editor as TipTapEditor } from "@tiptap/react";

import { containsMergeTags } from "utils/string";

import MergeTagChip from "./MergeTagChip";
import styles from "./styles";

interface Props {
  editor: TipTapEditor;
  missingValues: string[];
  subject?: string;
  // This prop is used for QuickSend Outreach.
  hasMergeTagCondition?: boolean;
}

const MergeTagWarning = ({
  editor,
  missingValues,
  subject,
  hasMergeTagCondition,
}: Props) => {
  const checkIfTemplateVarIsFilledOut = (templateVar: string) => {
    const missingVar = `{${templateVar}}`;
    return editor?.getText()?.includes?.(missingVar);
  };

  const displayWarningForEmail = () => {
    const variables = missingValues?.filter(checkIfTemplateVarIsFilledOut);
    const hasMergeTag =
      containsMergeTags(subject) ||
      hasMergeTagCondition ||
      containsMergeTags(editor.getHTML());

    const hasVars =
      editor && missingValues && variables && variables?.length > 0;

    if (hasVars) {
      return (
        <Typography variant="body2" sx={styles.errorWarningContainer}>
          We noticed some templating characters remaining in your message.
          Please edit these before sending.
        </Typography>
      );
    }

    if (hasMergeTag) {
      return (
        <Typography variant="body2" sx={styles.errorWarningContainer}>
          Make sure you also fill out <MergeTagChip mergeTag="{Brand Name}" />{" "}
          and <MergeTagChip mergeTag="{First Name}" />
        </Typography>
      );
    }

    return <></>;
  };

  return displayWarningForEmail();
};

export default MergeTagWarning;
